import { ReactComponent as QrCodeSvg } from "assets/Svgs/QrCode.svg";
import { ReactComponent as StikyNoteSvg } from "assets/Svgs/StikyNoteSvg.svg";
import i18n from "i18n/i18n";

import { Box, Button, Grid } from "@mui/material";
import NotificationCardItem from "../../../components/NotificationCardItem";
import { useNavigate } from "react-router-dom";
import { GetNotificationBorderColor } from "shared-functions/notification";
import { useEffect, useState } from "react";
import _ from "lodash";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {
  Document,
  Image,
  PDFDownloadLink,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import QrCodeComponent from "components/QRcode";
import { Card, Typography, Zoom } from "@mui/material";
import logo from "./logo.png";
import QrCode from "./qr-code.png";
import QRCode from "qrcode";
import { ReactComponent as Logo } from "assets/Svgs/logo.svg";

import Lightbox from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import "yet-another-react-lightbox/styles.css";
import { useBoundStore } from "store/store";

function Overview(props: any) {
  const navigate = useNavigate();

  const { machineData } = props;

  const [latestNotifications, setLatestNotifications] = useState<any>([]);
  const [typeschildURL, setTypeschildURL] = useState<any>("");
  const [openTypeschild, setOpenTypeschild] = useState<any>(false);

  useEffect(() => {
    
    if (machineData?.equipment?.hasnotification) {
      let latestNotifications = _.filter(
        machineData?.equipment?.hasnotification,
        function (notification) {
          return !(notification.notification.status == 2);
        }
      );
      latestNotifications = _.sortBy(latestNotifications, [
        "notification",
        "created",
      ]).reverse();
      setLatestNotifications(latestNotifications);
    } else {
      setLatestNotifications([]);
    }
  }, [machineData]);

  const [openDialog, setopenDialog] = useState(false);

  const handleCloseDialog = () => {
    setopenDialog(false);
  };

  const styless = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
    },
    image: {
      marginVertical: 10,
      marginHorizontal: 220,
      width: 100,
    },
    qrCode: {
      height: 300,
      width: 300,
      marginHorizontal: 120,
      marginVertical: 5,
    },
  });

  const MyDoc = () => (
   

    <Document>
      <Page style={styless.body}>
        <Image style={styless.image} src={logo} />

        <Image
          src={generateQR(machineData?.equipment?.nodeid)}
          style={styless.qrCode}
        />

        <Text style={styless.subtitle}>{machineData?.equipment?.name}</Text>

        <Text style={styless.subtitle}>
          {
            machineData?.equipment?.hasequipmenttype[0]?.equipmenttype
              ?.isequipmenttypeof[0]?.brand?.name
          }{" "}
          {machineData?.equipment?.hasequipmenttype[0]?.equipmenttype?.model}
        </Text>
      </Page>
    </Document>
  );

  const generateQR = async (text: any) => {
    try {
      return await QRCode.toDataURL(text);
    } catch (err) {
      console.error(err);
    }
  };

  const onImgClick = (e: any, url: any) => {
    e.preventDefault();
    setOpenTypeschild(true);
    setTypeschildURL(url);
  };

  const closeLightbox = () => {
    setOpenTypeschild(false);
  };

  const lang:any = useBoundStore((state) => state.lang);

  return (
    <div className="overviewTab">
      {openTypeschild && (
        <Lightbox
          open={openTypeschild}
          close={closeLightbox}
          slides={[{src: typeschildURL}]}
          plugins={[Download]}
        />
      )}

      <div className="pills">
        <div
          className="overviewPill"
          onClick={() => {
            setopenDialog(true);
          }}
        >
          <div>
            <QrCodeSvg />
          </div>
          <div>QR-Code</div>
        </div>
        <div
          className="overviewPill"
          onClick={(e) => {
            onImgClick(e, machineData?.equipment?.typenameplate?.url);
          }}
        >
          <div>
            <StikyNoteSvg />
          </div>
          <div>{i18n(lang).type_plate}</div>
        </div>
      </div>

      <div className="generalHeading" style={{ padding: "36px 0px 24px 0px" }}>
        {i18n(lang)?.current_reports}
      </div>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {latestNotifications?.map((item: any, index: any) => {
            return (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ paddingTop: "0px !important", paddingRight: "8px" }}
                key={index}
              >
                <NotificationCardItem
                  text={item.notification.title}
                  btColor={GetNotificationBorderColor(item.notification.type)}
                  statusColor={"red"}
                  type={item.notification.type}
                  status={item.notification.status}
                  notification={item.notification}
                  equipmentNodeId={machineData?.equipment?.nodeid}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>

      <Button
        variant="contained"
        sx={{ background: "var(--primary-color)", marginTop: "28px" }}
        className="lp125"
        onClick={() => {
          navigate("/create-notification", {
            state: {
              data: machineData,
              fromMachine: true,
              equipmentNodeId: machineData?.equipment?.nodeid,
            },
          });
        }}
      >
        {i18n(lang)?.create_new_notification}
      </Button>

      <Dialog
        open={openDialog}
        sx={{ backdropFilter: "blur(4px)" }}
        onClose={() => {
          handleCloseDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Zoom}
      >
        <DialogContent dividers className="QR_dialogContent">
      

          <div className="bxShadow qrCode_Wrapper">
            <div className="qrCode">
              <QrCodeComponent nodeid={machineData?.equipment?.nodeid} />
            </div>
            <div className="company">
              <div className="image">
                <Logo className="logoSvg" />
              </div>
              <div className="content">
                <div>
                  {machineData?.equipment?.hasequipmenttype &&
                    machineData?.equipment?.hasequipmenttype[0]?.equipmenttype
                      ?.isequipmenttypeof[0]?.brand?.name}
                </div>
                <div>
                  <span>
                    {machineData?.equipment?.hasequipmenttype &&
                      machineData?.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.isequipmenttypeof[0]?.brand?.name}

                    <em style={{ marginLeft: 5 }}>
                      {machineData?.equipment?.hasequipmenttype &&
                        machineData?.equipment?.hasequipmenttype[0]
                          ?.equipmenttype?.model}
                    </em>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="qrLink">
            <PDFDownloadLink
              document={<MyDoc />}
              fileName={machineData?.equipment?.name + "-QRCode.pdf"}
            >
              {({ loading }) =>
                loading ? "Loading document..." : "Download as PDF"
              }
            </PDFDownloadLink>
          </div>
        </DialogContent>
      
      </Dialog>
    </div>
  );
}

export default Overview;
